import { darken, ThemeOptions } from "@mui/material/styles";

import { getInvertColor } from "utils/themeUtils";

import TimeIcon from "assets/svg/time-gray.svg";

export const outlinedInputOverrides: ThemeOptions["components"] = {
	MuiOutlinedInput: {
		styleOverrides: {
			root: ({ ownerState: { color }, theme }) => {
				const mainColor = theme.palette[`${color}`]?.main || theme.palette.primary.main;
				const isLight = getInvertColor(mainColor) === theme.palette.dirtyWhite["2000"];
				const isPrimaryOrSecondary = ["primary", "secondary"].includes(`${color}`);

				return {
					minHeight: theme.spacing(10),
					fontWeight: 400,
					fontSize: theme.typography.pxToRem(16),
					color: theme.palette.dirtyWhite["2000"],
					lineHeight: "150%",
					backgroundColor: theme.palette.common.white,
					borderRadius: theme.spacing(2),

					"&.Mui-disabled": {
						color: theme.palette.dirtyWhite["800"],
						backgroundColor: theme.palette.dirtyWhite["200"],
					},

					"&:hover .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline": {
						borderColor: isPrimaryOrSecondary && isLight ? darken(mainColor, 0.5) : mainColor,
					},

					"&.MuiInputBase-adornedStart": {
						paddingLeft: theme.spacing(3),
					},

					"&.MuiInputBase-adornedEnd": {
						paddingRight: theme.spacing(3),
					},
				};
			},

			input: ({ theme }) => ({
				paddingTop: theme.spacing(2),
				paddingBottom: theme.spacing(2),
				paddingLeft: theme.spacing(3),
				paddingRight: theme.spacing(3),
				scrollbarWidth: "none",
				borderRadius: "inherit",

				"::placeholder": {
					color: theme.palette.black["500"],
					fontSize: theme.typography.pxToRem(16),
					fontWeight: 400,
					opacity: 1,
					lineHeight: "150%",
				},

				"&.Mui-disabled": {
					backgroundColor: "inherit",
					color: "inherit",
					cursor: "not-allowed",
				},

				"&.Mui-disabled::placeholder": {
					color: theme.palette.dirtyWhite["800"],
				},

				"&.MuiInputBase-inputAdornedStart": {
					paddingLeft: 0,
				},

				"&.MuiInputBase-inputAdornedEnd": {
					paddingRight: 0,
				},

				"&::-ms-reveal": {
					display: "none",
				},

				"&::-ms-clear": {
					display: "none",
				},

				"&::-webkit-credentials-auto-fill-button": {
					display: "none",
				},

				"&::-webkit-clear-button": {
					display: "none",
				},

				"&::-webkit-search-cancel-button": {
					WebkitAppearance: "none",
					pointerEvents: "none",
				},

				"&::-webkit-calendar-picker-indicator": {
					WebkitAppearance: "none",
					cursor: "pointer",
					width: theme.spacing(3),
					height: theme.spacing(3),
					background: `url(${TimeIcon}) no-repeat center center`,
					backgroundSize: "contain",
				},
			}),

			notchedOutline: ({ theme }) => ({
				borderColor: theme.palette.dirtyWhite["400"],

				".Mui-disabled &": {
					borderColor: theme.palette.dirtyWhite["600"],
				},
			}),

			inputMultiline: {
				paddingTop: 0,
				paddingBottom: 0,
				paddingLeft: 0,
				paddingRight: 0,
			},
		},
	},
};
